import { useEffect, useRef } from 'react';
import { reaction } from 'mobx';
import { useStore } from 'src/stores';
/**
 * Starts a new chat when the app's selected company changes (a staff switch, an impersonation), so a conversation,
 * a live handoff's banner and its poll never carry over into another company. A MobX reaction on the store's company
 * name, so the calling component needs no observer wrapper.
 */
export function useResetOnCompanyChange(reset) {
  const store = useStore();
  const latest = useRef(reset);
  latest.current = reset;
  useEffect(() => reaction(() => {
    var _store$admin;
    return store === null || store === void 0 || (_store$admin = store.admin) === null || _store$admin === void 0 ? void 0 : _store$admin.companyName;
  }, () => latest.current()), [store]);
}